import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { env } from '../../Env.js';
import { useLocation } from '../../hooks/useLocation.js';
import { Heading } from '../../ui-kit/Heading/Heading.js';
import { useLocationDialog } from '../../ui-kit/LocationDialog/useLocationDialog.js';
import { getBasePath } from '../../utils/getBasePath.js';
import { StickyBottomMenuDialog } from './StickyBottomMenuDialog.js';
export const BurgerMenuDialog = JSX(({ menuRef, menuItem, locationDialogProps, closeAll }) => {
    const locationDialog = useLocationDialog(locationDialogProps || {});
    const [{ name: location }] = useLocation();
    const menuDimensions = menuRef?.current?.getBoundingClientRect();
    const basePath = getBasePath(env.SITE_URL);
    const handleIframeLoad = () => {
        const iframeWindow = globalThis.frames['burger-menu-iframe'];
        const ifDoc = document.getElementsByTagName('iframe')['iframe-dialog'];
        ifDoc.style.height = String(ifDoc?.contentWindow?.document.body.offsetHeight) + 'px';
        iframeWindow.postMessage({ type: 'currentTab', data: basePath?.slice(1) }, '*');
        iframeWindow.postMessage({ type: 'currentLocation', data: location }, '*');
    };
    useEffect(() => {
        const iframeWindow = globalThis.frames['burger-menu-iframe'];
        iframeWindow.postMessage({ type: 'currentLocation', data: location }, '*');
    }, [location]);
    useEffect(() => {
        const onMessage = (e) => {
            if (e.data.type === 'location') {
                locationDialog.open();
            }
            if (e.data.type === 'reload') {
                closeAll();
            }
            if (e.data.type === 'resize') {
                const ifDoc = document.getElementsByTagName('iframe')['iframe-dialog'];
                if (ifDoc && ifDoc.style) {
                    ifDoc.style.height = String(e.data.data) + 'px';
                }
            }
        };
        globalThis.addEventListener('message', onMessage);
        return () => {
            globalThis.removeEventListener('message', onMessage);
        };
    }, []);
    return (_jsx(StickyBottomMenuDialog, { onClick: (e) => e.stopPropagation(), head: _jsx("div", { className: "flex items-center justify-center px-xl", children: _jsx(Heading, { as: "h4", title: menuItem?.title, className: "font-medium" }) }), children: _jsx("div", { className: "bg-white pb-20 pt-1 text-l", children: _jsx("iframe", { id: "iframe-dialog", name: "burger-menu-iframe", onLoad: () => handleIframeLoad(), src: menuItem?.src, width: menuDimensions?.width || 0 }) }) }));
});
//# sourceMappingURL=BurgerMenuDialog.js.map